export type WorkScheduleShiftKind = 'shift' | 'day-off' | 'half-day'

export type WorkScheduleDayHeader = {
  name: string
  date: string
}

export type WorkScheduleDayShift = {
  kind: WorkScheduleShiftKind
  label: string
  /** Date-specific override time shown below the regular schedule. */
  overrideLabel?: string
}

export type WorkScheduleStaffRow = {
  id: string
  name: string
  shifts: WorkScheduleDayShift[]
}

export type WorkSchedulePaginationProps = {
  currentPage: number
  pageSize: number
  totalRecords: number
  pageSizeOptions?: number[]
  onPageChange: (page: number) => void
  onPageSizeChange: (pageSize: number) => void
}

export type WorkScheduleProps = {
  dayHeaders: WorkScheduleDayHeader[]
  staff: WorkScheduleStaffRow[]
  /** When true, body rows are omitted (headers still render). */
  loading?: boolean
  emptyMessage?: string
  staffColumnLabel?: string
  darkMode?: boolean
  className?: string
  ariaLabel?: string
  pagination?: WorkSchedulePaginationProps
}

export const WORK_SCHEDULE_DEMO_DAY_HEADERS: WorkScheduleDayHeader[] = [
  { name: 'Monday', date: 'Aug 3, 2026' },
  { name: 'Tuesday', date: 'Aug 4, 2026' },
  { name: 'Wednesday', date: 'Aug 5, 2026' },
  { name: 'Thursday', date: 'Aug 6, 2026' },
  { name: 'Friday', date: 'Aug 7, 2026' },
  { name: 'Saturday', date: 'Aug 8, 2026' },
  { name: 'Sunday', date: 'Aug 9, 2026' },
]

const weekdayShift = (label: string): WorkScheduleDayShift => ({
  kind: 'shift',
  label,
})

const dayOff = (): WorkScheduleDayShift => ({
  kind: 'day-off',
  label: 'Day-off',
})

const halfDay = (label: string): WorkScheduleDayShift => ({
  kind: 'half-day',
  label,
})

export const WORK_SCHEDULE_DEMO_STAFF: WorkScheduleStaffRow[] = [
  {
    id: '1',
    name: 'Dr. Ava Smith',
    shifts: [
      weekdayShift('8 AM - 5 PM'),
      weekdayShift('8 AM - 5 PM'),
      {
        kind: 'shift',
        label: '8 AM - 5 PM',
        overrideLabel: '9 AM - 1 PM',
      },
      weekdayShift('8 AM - 5 PM'),
      weekdayShift('8 AM - 5 PM'),
      dayOff(),
      dayOff(),
    ],
  },
  {
    id: '2',
    name: 'Dr. Marcus Jones',
    shifts: [
      weekdayShift('9 AM - 6 PM'),
      weekdayShift('9 AM - 6 PM'),
      weekdayShift('9 AM - 6 PM'),
      halfDay('9 AM - 1 PM'),
      weekdayShift('9 AM - 6 PM'),
      dayOff(),
      dayOff(),
    ],
  },
  {
    id: '3',
    name: 'Jamie Rivera',
    shifts: [
      weekdayShift('8 AM - 4 PM'),
      dayOff(),
      weekdayShift('8 AM - 4 PM'),
      weekdayShift('8 AM - 4 PM'),
      weekdayShift('8 AM - 4 PM'),
      weekdayShift('9 AM - 1 PM'),
      dayOff(),
    ],
  },
  {
    id: '4',
    name: 'Priya Lee',
    shifts: [
      weekdayShift('10 AM - 7 PM'),
      weekdayShift('10 AM - 7 PM'),
      weekdayShift('10 AM - 7 PM'),
      weekdayShift('10 AM - 7 PM'),
      dayOff(),
      dayOff(),
      dayOff(),
    ],
  },
  {
    id: '5',
    name: 'Daniel Chen',
    shifts: [
      dayOff(),
      weekdayShift('8 AM - 5 PM'),
      weekdayShift('8 AM - 5 PM'),
      weekdayShift('8 AM - 5 PM'),
      weekdayShift('8 AM - 5 PM'),
      dayOff(),
      dayOff(),
    ],
  },
]
